import React from 'react'
import AiHero from '../../Components/Automation/AiHero'
import OurServiceOffer from '../../Components/Automation/OurServiceOffer'
import { ChevronRight, Contact } from 'lucide-react'
import Perspectives from '../../Components/Accelerating/Perspectives'
import RelatedServices from '../../Components/Accelerating/RelatedServices'
import AccContact from '../../Components/Accelerating/AccContact'
import Banner from '../../Components/Banner'
import { Helmet } from 'react-helmet-async'
import ContactSection from '../../Components/home/ContactSection'

const relatedService = [
    {
        id: 1,
        title: "AI & Intelligent Automation",
        description: "Use machine learning and cognitive computing to take the complexity out of your business processes, automating work in a smarter, more reliable way while improving efficiency and accuracy.",
        image: "/assets/product/p1.png",
        link: "/ai-intelligent-automation"
    },
    {
        id: 2,
        title: "Cloud & DevOps Engineering",
        description: "Speed up software delivery and build strong, scalable cloud infrastructure using modern practices that keep your systems reliable, flexible, and ready to grow with your business.",
        image: "/assets/product/p3.png",
        link: "/cloud-dev-ops-engineering"
    },
    {
        id: 3,
        title: "Product Engineering & Digital",
        description: "We help turn your ideas into real digital products with complete design and engineering support that actually works in the market.",
        image: "/assets/product/p4.png",
        link: "/product-engineering-digital"
    },
    {
        id: 4,
        title: "Managed Services & Staff Augmentation",
        description: "Grow your tech capabilities whenever you need with our dedicated experts and complete IT support, designed to scale smoothly with your business.",
        image: "/assets/product/p2.png",
        link: "/managed-services-staff-augmentation"
    }
];
const data = [
    {
        id: 1,
        category: "QE STRATEGY",
        title: "Shift-Left Testing: Integrating Quality Early in the CI/CD Pipeline",
        link: "#"
    },
    {
        id: 2,
        category: "AI IN TESTING",
        title: "The Future of Test Automation: Self-Healing Scripts and AI Agents",
        link: "#"
    },
    {
        id: 3,
        category: "PERFORMANCE",
        title: "Preparing for Peak Traffic: A Guide to Continuous Performance Engineering",
        link: "#"
    },
    {
        id: 4,
        category: "DEVSECOPS",
        title: "Embedding Security Testing into the DevOps Lifecycle",
        link: "#"
    }
];

const service = [
    {
        id: 1,
        title: "QA & Test Automation",
        category: "service",
        desc: "Speeding up release cycles with smart, AI-powered automation that helps teams deliver reliable, high-quality software without defects, every time.",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]",
        link: "/",
    },
    {
        id: 2,
        title: "Performance Engineering",
        category: "service",
        desc: "Enhancing application speed, scalability, and stability during peak usage so users always enjoy a smooth, reliable, and seamless experience.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]",
        link: "/performance-engineering",
    },
    {
        id: 3,
        title: "Security Testing",
        category: "service",
        desc: "We focus on catching security issues early so they never become real problems. Through careful penetration testing and both static and dynamic code analysis, we help keep your systems safe, stable, and reliable.",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]",
        link: "/",
    },
    {
        id: 4,
        title: "Test Strategy & Consulting",
        category: "service",
        desc: "We help you build a clear quality roadmap with the right tools, processes, and testing practices for reliable, consistent results.",
        defaultBg: "bg-gradient-to-bl from-[#01386A] to-[#6A85B6]",
        link: "/",
    },
]

function QualityEngineeringPerformance() {
    return (
        <div>
            <Helmet>
    <title>
        Quality Engineering & Performance Services | Software Testing | Mobikode
    </title>

    <meta
        name="description"
        content="Mobikode delivers quality engineering and performance services to improve software reliability, automate testing, strengthen security, optimize application performance, and accelerate confident releases."
    />

    <meta
        name="keywords"
        content="Quality Engineering Services, Quality Engineering Company, Software Testing Services, QA Automation Services, Test Automation Services, AI Powered Test Automation, Performance Engineering Services, Application Performance Testing, Security Testing Services, Penetration Testing Services, Static Code Analysis, Dynamic Code Analysis, Test Strategy Consulting, Software Quality Assurance"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/capabilities/quality-engineering"
    />

    <meta
        property="og:title"
        content="Quality Engineering & Performance Services | Software Testing | Mobikode"
    />

    <meta
        property="og:description"
        content="Build reliable, secure, and high-performing software with Mobikode's quality engineering services, including AI-powered test automation, performance engineering, security testing, and quality consulting."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/capabilities/quality-engineering"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/what/c7.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Quality Engineering & Performance Services | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode's quality engineering solutions for test automation, performance engineering, security testing, and test strategy to deliver reliable and high-performing software."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/what/c7.png"
    />
</Helmet>
            <AiHero title="Quality Engineering" imgData="/assets/what/c7.png" />
            <section className="w-full py-[50px] lg:py-[80px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row h-auto lg:h-[323px] group">

                        <div className="overflow-hidden w-full lg:max-w-[624px] h-[250px] lg:h-full relative z-10">
                            <img
                                src="/assets/what/item16.png"
                                alt="Quality Engineering"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>

                        <div className="relative z-20 w-full lg:max-w-[656px] bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] 
                            px-[20px] py-[30px] lg:px-[40px] lg:py-[30px] flex flex-col justify-center
                            -mt-6 lg:mt-0 lg:ml-0">
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-[500] font-graphik text-justify">
                                At Mobikode, we believe fast delivery should never mean lower quality. Our Quality Engineering & Performance approach goes beyond traditional testing; we focus on building reliable, high-performing applications from the start. With AI-powered automation, smart insights, and continuous checks, we make sure your products run smoothly, scale easily, and stay dependable in real-world use.
                            </p>
                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>

                        </div>

                    </div>
                </div>
            </section>
            <OurServiceOffer service={service} />
            {/* <section className='overflow-hidden'>
                <div className="max-w-[1440px] lg:pb-[80px] pb-[40px] w-full mx-auto lg:px-[80px] px-[20px]">
                    <h6 className="text-center font-[600] lg:text-[31px] text-[20px] lg:pb-[80px] pb-[40px] lg:leading-[40px] leading-[30px] text-[#01386A]">Spotlight</h6>

                    <div className="flex lg:flex-row flex-col gap-5">

                        <div className="w-full lg:w-[65%] mx-auto relative group">
                            <div className="relative w-full h-[350px] lg:h-auto lg:aspect-auto">
                                <img src="/assets/what/img6.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px]">Achieving 99.9% Defect-Free Releases for a Global FinTech Platform</h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-full lg:w-[35%] mx-auto grid gap-[20px]">

                            <div className="relative h-[300px] lg:h-auto">
                                <img src="/assets/what/img5.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px] line-clamp-2">
                                            Reducing Regression Testing Time by 70% with AI...
                                        </h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="relative h-[300px] lg:h-auto">
                                <img src="/assets/what/img7.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px] line-clamp-2">
                                            Scaling for Black Friday: Performance Engineering...
                                        </h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section> */}
            <section className="w-full pb-[40px] lg:pb-[80px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[15px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row lg:items-center group lg:h-[507px]">
                        <div className="relative lg:absolute top-0 right-0 w-full lg:max-w-[656px] h-[250px] md:h-[350px] lg:h-full bg-gray-100 overflow-hidden">
                            <img
                                src="/assets/what/img8.png"
                                alt="Mobikode QE Advantage"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>
                        <div className="relative z-20 w-[92%] sm:w-[85%] lg:w-full max-w-[719px] mx-auto lg:mx-0 bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] px-[20px] py-[30px] lg:px-[60px] lg:py-[80px] -mt-[40px] lg:mt-0">
                            <h3 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora mb-[15px] lg:mb-[35px] leading-[1.3]">
                                The Mobikode Quality Advantage
                            </h3>
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-graphik font-[500] text-justify">
                                At Mobikode, we don’t treat quality assurance as a final step; it's part of how we build from the very beginning. Our Quality Engineering approach is about preventing issues early, not just fixing them later. With smart automation, predictive insights, and real hands-on experience, we make sure your software is reliable, secure, and ready for real-world use. </p>
                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <Perspectives data={data} /> */}
            <RelatedServices relatedService={relatedService} />
            {/* <section className='relative'>
                <img src="/assets/product/bg1.jpg" className='lg:h-[683px] h-[800px] w-full object-cover' alt="" />
                <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px] top-1/2 -translate-y-1/2 absolute left-1/2 -translate-x-1/2">
                    <AccContact />
                </div>
            </section> */}
            <Banner title="Quality Engineering" text=" Empowering businesses with intelligent, autonomous AI solutions that drive efficiency and innovation." />
            <ContactSection />
        </div>
    )
}

export default QualityEngineeringPerformance